
import mAxiosApi from "@/api";
import { computed, defineComponent, onMounted, reactive, watch} from "vue";

export default defineComponent({
  name: "Generalinfos",
  props: {
    datas: Object,
    permission: Boolean,
    editData: Boolean,
  },

  setup(props, {emit}) {
    const state = reactive({
      datas: {...props.datas},
      allUsers: [] as any,
      CRMusers: [] as any,
    })
    if(state.datas.emp_x_montant_mensuel_transport == null) state.datas.emp_x_montant_mensuel_transport = 0;

    const vehiculeLibelle = computed(() => {
      const parts = [state.datas.veh_marque, state.datas.veh_modele, state.datas.veh_immat].filter(Boolean);
      return parts.join(' ');
    });

    watch(() => props.datas, (newData) => {
      state.datas = {...newData};
      if(state.datas.emp_x_montant_mensuel_transport == null) state.datas.emp_x_montant_mensuel_transport = 0;
    });

    const setNewData = () => {
      emit("setNewData", state.datas)
    }

    onMounted(async() => {
      const getUsersCRM = await mAxiosApi.prototype.getAxios("/getUsersCRM");
      const getAllUsers = await mAxiosApi.prototype.getAxios("/getAllUsers");
      state.allUsers = getAllUsers.results;
      state.CRMusers = getUsersCRM.results;
    })

    return{
      state,
      setNewData,
      vehiculeLibelle,
    }
  },
});
